import React, { memo } from 'react';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
import { ChevronLeftIcon, ChevronRightIcon } from "../icons";
var cx = classNames.bind(styles);
export var PageContainer = /*#__PURE__*/memo(function (_ref) {
  var current = _ref.current,
    total = _ref.total,
    children = _ref.children,
    setNearPage = _ref.setNearPage,
    testName = _ref.testName;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('wrapper'),
    "data-component": testName
  }, current > 1 && /*#__PURE__*/React.createElement("button", {
    className: cx('reset-button'),
    onClick: function onClick() {
      return setNearPage(current - 1);
    },
    type: "submit"
  }, /*#__PURE__*/React.createElement(ChevronLeftIcon, null)), children, current !== total && /*#__PURE__*/React.createElement("button", {
    className: cx('reset-button'),
    onClick: function onClick() {
      return setNearPage(current + 1);
    },
    type: "submit"
  }, /*#__PURE__*/React.createElement(ChevronRightIcon, null)));
});